import Vue from 'vue';
import Vuex from 'vuex';

/* modules */
import messages       from '@/store/modules/messages';
import currencies from '@/store/dictionaries/currencies';
import vatRates from '@/store/dictionaries/vatRates';

import dictionaries from '@/store/dictionaries';

Vue.use(Vuex);

const storeConfig = {
    modules: {
        dictionaries,
        messages,
        currencies,
        vatRates,
    },
};

export default new Vuex.Store(storeConfig);

export { storeConfig };
